import { postWithFullResponse } from '@citrite/http';

type CtxStoreTicketType = {
	ticketId: string;
};

// Note: we don't include the Citrix/StoreWeb/ path here since that should come from the
// StoreUrlPath. Reason being in onprem deployments, the /StoreWeb/ can be different
export const REQUEST_TICKET_PATH = 'Tickets/RequestStoreTicket';

export namespace CtxStoreTicket {
	export async function request(): Promise<string | undefined> {
		try {
			const responseTicket = await postWithFullResponse<CtxStoreTicketType>(
				REQUEST_TICKET_PATH,
				{}
			);
			return responseTicket?.data?.ticketId;
		} catch {
			return undefined;
		}
	}
}
